export default "__VITE_ASSET__DblXXrBm__"